import {fetchCraftData} from './data_providers';

export const companyName = company =>
  fetchCraftData(company.info)
    .then(data => data.displayName);
